module.exports = __webpack_public_path__ + "img/wep_spear01.c3976129.png";